import { render, staticRenderFns } from "./advoutstand.vue?vue&type=template&id=4f68af0d&scoped=true"
import script from "./advoutstand.vue?vue&type=script&lang=js"
export * from "./advoutstand.vue?vue&type=script&lang=js"
import style0 from "./advoutstand.vue?vue&type=style&index=0&id=4f68af0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f68af0d",
  null
  
)

export default component.exports